import React from 'react';
import {
  Box,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  InputAdornment,
  SvgIcon,
  Card,
  Chip
} from '@material-ui/core';
import { Search as SearchIcon } from 'react-feather';
import { useDispatch } from 'react-redux';
import {
  getListDevice,
  updateDeviceTransfer
} from 'src/features/deviceSlice';
import {
  syncOrderDeviceTypes,
  updateOrderStatus,
  updateOrderInList
} from 'src/features/orderSlice';
import { showGlobalToast } from 'src/features/uiSlice';
import { messageToastType_const } from 'src/app/constant/config';

const SerialDialog = ({
  editingOrder,
  setEditingOrder,
  newSerial,
  setNewSerial,
  editingDevices,
  setEditingDevices,
  isSale,
  fetchListOrders
}) => {
  const dispatch = useDispatch();

  const formatErrorWithSerials = (msg, devicesList) => {
    let newMsg = msg;
    const idRegex = /ID (\d+)/g;
    const matches = msg.matchAll(idRegex);

    [...matches].forEach(match => {
      const idStr = match[0];
      const idNum = parseInt(match[1]);
      let serial = null;
      devicesList.forEach(d => {
        const foundIdx = (d.device_ids || []).indexOf(idNum);
        if (foundIdx !== -1) {
          serial = (d.serials || [])[foundIdx];
        }
      });
      if (serial) {
        newMsg = newMsg.replace(idStr, serial);
      }
    });

    return newMsg
      .replace(/các ID:/g, 'các Serial:')
      .replace(/các ID :/g, 'các Serial:')
      .replace(/ID:/g, 'Serial:')
      .replace(/ID :/g, 'Serial :')
      .replace(/ID /g, 'Serial ');
  };

  const handleSaveSerials = () => {
    const isMissing = editingDevices.some(
      d => (d.serials?.length || 0) < d.quantity
    );
    if (isMissing) {
      dispatch(
        showGlobalToast({
          message: 'Vui lòng quét đủ tất cả serial cho thiết bị trước khi lưu!',
          type: messageToastType_const.warning
        })
      );
      return;
    }

    const payload = {
      items: editingDevices.map(d => ({
        order_device_type_id: d.id,
        device_ids: d.device_ids || []
      }))
    };

    dispatch(
      syncOrderDeviceTypes({
        id: editingOrder.id,
        data: payload,
        suffix: '/order_device_type'
      })
    ).then(res => {
      if (res.meta.requestStatus === 'fulfilled') {
        if ((editingOrder.status || 0) < 1) {
          const isOffline =
            editingOrder.delivery_method === 0 ||
            editingOrder.installer === 'VGPS lắp đặt';
          const targetStatus = isOffline ? 2 : 1;
          const targetNote = isOffline
            ? 'Sẵn sàng giao (Offline)'
            : 'Đang xử lý';
          dispatch(
            updateOrderStatus({
              id: editingOrder.id,
              data: { status: targetStatus, note: targetNote },
              suffix: '/status'
            })
          ).then(statusRes => {
            if (statusRes.meta.requestStatus === 'fulfilled') {
              dispatch(
                updateOrderInList({
                  id: editingOrder.id,
                  data: { status: targetStatus }
                })
              );
              fetchListOrders();
            }
            setEditingOrder(null);
          });
        } else {
          fetchListOrders();
          setEditingOrder(null);
        }
      } else {
        const errorMsg = res.payload?.message || '';
        let displayMsg =
          errorMsg || 'Lưu Serial thất bại. Vui lòng kiểm tra lại!';
        if (errorMsg.includes('Device type mismatch')) {
          displayMsg = 'Serial sai loại thiết bị!';
        } else if (
          errorMsg.includes(
            'Thiết bị đã được dùng ở nhóm khác trong đơn hàng này'
          )
        ) {
          displayMsg = 'Serial này đã tồn tại trong đơn hàng khác!';
        } else {
          displayMsg = formatErrorWithSerials(displayMsg, editingDevices);
        }
        dispatch(
          showGlobalToast({
            message: displayMsg,
            type: messageToastType_const.error
          })
        );
      }
    });
  };

  return (
    <Dialog
      open={Boolean(editingOrder)}
      onClose={() => setEditingOrder(null)}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle disableTypography style={{ padding: '16px 24px' }}>
        <Box>
          <Typography
            variant="h5"
            style={{ fontWeight: 700, color: '#1a1f36' }}
          >
            Serial thiết bị
          </Typography>
          <Typography variant="body2" color="textSecondary">
            {editingOrder?.customer_name || editingOrder?.customerName}
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent dividers style={{ backgroundColor: '#fcfcfd' }}>
        {!(
          isSale ||
          editingOrder?.status >= 4 ||
          editingOrder?.status === -1
        ) && (
          <Box mb={3} mt={1}>
            <TextField
              fullWidth
              autoFocus
              label="Bắn QR Code / Quét Serial tại đây..."
              placeholder="Nhấn Enter để thêm..."
              value={newSerial}
              onChange={e => setNewSerial(e.target.value)}
              onKeyDown={e => {
                if (e.key === 'Enter' && newSerial.trim()) {
                  const rawSn = newSerial.trim();
                  const sn = rawSn.includes(',')
                    ? rawSn
                        .split(',')
                        .pop()
                        .trim()
                    : rawSn;

                  const hasAvailableSlot = editingDevices.some(
                    d => (d.serials?.length || 0) < d.quantity
                  );
                  if (!hasAvailableSlot) {
                    dispatch(
                      showGlobalToast({
                        message: 'Đã đủ số lượng serial cho tất cả thiết bị!',
                        type: messageToastType_const.info
                      })
                    );
                    return;
                  }

                  if (editingDevices.some(d => d.serials?.includes(sn))) {
                    dispatch(
                      showGlobalToast({
                        message: 'Serial này đã tồn tại trong đơn hàng!',
                        type: messageToastType_const.warning
                      })
                    );
                    return;
                  }

                  dispatch(
                    getListDevice({
                      keywords: sn,
                      page: 1,
                      page_size: 1000
                    })
                  ).then(res => {
                    const devices =
                      res.payload?.payload?.devices ||
                      res.payload?.devices ||
                      [];
                    const device = devices.find(
                      d =>
                        String(d.serial || '')
                          .trim()
                          .toLowerCase() === sn.trim().toLowerCase() ||
                        String(d.imei || '')
                          .trim()
                          .toLowerCase() === sn.trim().toLowerCase()
                    );

                    if (device) {
                      const newEditingDevices = [...editingDevices];
                      const apiDeviceTypeName =
                        device.deviceType?.name ||
                        device.device_type?.name ||
                        null;

                      let targetIdx = -1;
                      if (apiDeviceTypeName) {
                        targetIdx = newEditingDevices.findIndex(
                          d =>
                            (
                              d.device_type_name ||
                              d.type ||
                              ''
                            ).toLowerCase() ===
                              apiDeviceTypeName.toLowerCase() &&
                            (d.serials?.length || 0) < d.quantity
                        );
                      }

                      if (targetIdx === -1) {
                        dispatch(
                          showGlobalToast({
                            message: `Serial là loại '${apiDeviceTypeName}', không khớp với bất kỳ loại thiết bị nào trong đơn hàng!`,
                            type: messageToastType_const.error
                          })
                        );
                        return;
                      }

                      if (targetIdx !== -1) {
                        const targetDevice = newEditingDevices[targetIdx];
                        newEditingDevices[targetIdx] = {
                          ...targetDevice,
                          device_ids: [
                            ...(targetDevice.device_ids || []),
                            device.id
                          ],
                          serials: [...(targetDevice.serials || []), sn]
                        };
                        setEditingDevices(newEditingDevices);
                        setNewSerial('');
                      }
                    } else {
                      if (devices.length === 0) {
                        dispatch(
                          showGlobalToast({
                            message: `Không tìm thấy serial '${sn}' trong kho!`,
                            type: messageToastType_const.error
                          })
                        );
                      } else {
                        dispatch(
                          showGlobalToast({
                            message: `Tìm thấy ${devices.length} kết quả nhưng không có serial nào khớp '${sn}'!`,
                            type: messageToastType_const.warning
                          })
                        );
                      }
                    }
                  });
                }
              }}
              variant="outlined"
              InputLabelProps={{
                shrink: true,
                style: {
                  backgroundColor: 'white',
                  padding: '0 4px',
                  marginLeft: -4
                }
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SvgIcon fontSize="small" color="action">
                      <SearchIcon />
                    </SvgIcon>
                  </InputAdornment>
                )
              }}
            />
          </Box>
        )}

        <Box display="flex" flexDirection="column" style={{ gap: 20 }}>
          {editingDevices.map((device, idx) => (
            <Card
              key={idx}
              variant="outlined"
              style={{
                padding: 16,
                borderRadius: 12,
                border: '1px solid #e0e3ef'
              }}
            >
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                mb={1.5}
              >
                <Typography
                  style={{
                    fontWeight: 700,
                    color: '#1a73e8',
                    fontSize: 14
                  }}
                >
                  {device.device_type_name || device.type}
                </Typography>
                <Chip
                  label={`${device.serials?.length || 0} / ${
                    device.quantity
                  }`}
                  color={
                    device.serials?.length === device.quantity
                      ? 'primary'
                      : 'default'
                  }
                  size="small"
                  style={{ fontWeight: 700 }}
                />
              </Box>
              <Box display="flex" flexWrap="wrap" style={{ gap: 6 }}>
                {device.serials?.map((sn, sIdx) => (
                  <Chip
                    key={sIdx}
                    label={sn}
                    onDelete={
                      isSale ||
                      editingOrder?.status >= 4 ||
                      editingOrder?.status === -1
                        ? undefined
                        : () => {
                            const newEditingDevices = [...editingDevices];
                            newEditingDevices[idx] = {
                              ...device,
                              serials: device.serials.filter(
                                (_, i) => i !== sIdx
                              ),
                              device_ids: (device.device_ids || []).filter(
                                (_, i) => i !== sIdx
                              )
                            };
                            setEditingDevices(newEditingDevices);
                          }
                    }
                    variant="outlined"
                    size="small"
                    style={{
                      background: 'white',
                      borderColor: '#1a73e840',
                      fontWeight: 500
                    }}
                  />
                ))}
              </Box>
            </Card>
          ))}
        </Box>
      </DialogContent>
      <DialogActions style={{ padding: '16px 24px' }}>
        <Button
          onClick={() => setEditingOrder(null)}
          color="default"
          style={{ textTransform: 'none', fontWeight: 600 }}
        >
          Đóng
        </Button>
        {!isSale &&
          editingOrder?.status < 4 &&
          editingOrder?.status !== -1 &&
          (editingOrder.agency_id || editingOrder.agency?.id) && (
            <Button
              variant="contained"
              color="secondary"
              onClick={() => {
                const list_device_id = editingDevices.reduce(
                  (acc, d) => [...acc, ...(d.device_ids || [])],
                  []
                );
                if (list_device_id.length === 0) {
                  dispatch(
                    showGlobalToast({
                      message: 'Vui lòng quét đủ serial trước khi chuyển kho!',
                      type: messageToastType_const.warning
                    })
                  );
                  return;
                }
                const agencyId =
                  editingOrder.agency_id || editingOrder.agency?.id;
                dispatch(
                  updateDeviceTransfer({
                    agency_id: agencyId,
                    list_device_id: list_device_id
                  })
                ).then(res => {
                  if (res.meta.requestStatus === 'fulfilled') {
                    fetchListOrders();
                  }
                });
              }}
              style={{
                textTransform: 'none',
                fontWeight: 600,
                padding: '6px 24px'
              }}
            >
              Chuyển kho
            </Button>
          )}
        {!isSale &&
          editingOrder?.status < 4 &&
          editingOrder?.status !== -1 && (
            <Button
              variant="contained"
              color="primary"
              onClick={handleSaveSerials}
              style={{
                textTransform: 'none',
                fontWeight: 600,
                padding: '6px 24px'
              }}
            >
              Lưu serial
            </Button>
          )}
      </DialogActions>
    </Dialog>
  );
};

export default SerialDialog;
